import { render, staticRenderFns } from "./company_nav.vue?vue&type=template&id=bd313ed4&"
import script from "./company_nav.vue?vue&type=script&lang=js&"
export * from "./company_nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports